module.exports = __webpack_public_path__ + "static/media/qlpp-text-mock.7fc0746e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qlpp-text-mock.png
// module id = 201
// module chunks = 0